import { Form } from 'antd';
import generatePicker from 'antd/es/date-picker/generatePicker';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { dateGenerateConfig } from 'app/components/fields/dateGenerateConfig';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { format } from 'app/utils/dayjs';

const { TimePicker } = generatePicker(dateGenerateConfig);

export const Time = () => {
  const form = Form.useFormInstance();
  const formValues = Form.useWatch(['time'], form);
  const { isEditMode } = useContext(ViewEditModeContext);

  return (
    <FormLineLayout
      label="Time"
      description="If applicable, it will be highlighted in the activity title"
      disabled={!isEditMode}
    >
      <Form.Item name="time">
        {isEditMode ? (
          <TimePicker format="HH:mm" />
        ) : (
          <span className="view-data">
            {formValues ? format(formValues, 'HH:mm') : 'ø empty'}
          </span>
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
